import "./atoms-v2886.js";
import { noop as e } from "./atoms-v2887.js";
import { createRenderBatcher as r } from "./atoms-v2986.js";
const { schedule: o, cancel: n, state: c, steps: i } = r(typeof requestAnimationFrame < "u" ? requestAnimationFrame : e, !0);
export {
  n as cancelFrame,
  o as frame,
  c as frameData,
  i as frameSteps
};
